<app-header
  #header
  *ngIf="token$ | async"
  style="position: fixed; top: 0; width: 100vw; z-index: 10"
  class="p-fixed w-screen"
  (showSideMenu)="isSidebarVisible = true"
></app-header>

<ng-container *ngIf="token$ | async">
  <!-- <app-side-menu
    style="position: fixed; top: 55px; z-index: 9"
    class="flex-none"
  ></app-side-menu> -->
 <app-side-menu
    *ngIf="!(isMobile$ | async)"
    class="flex-none"
    [style.position]="'fixed'"
    [style.top]="'55px'"
    [style.z-index]="'9'"
  />

  <p-sidebar
    *ngIf="isMobile$ | async"
    [(visible)]="isSidebarVisible"
    [style]="{ width: '290px' }"
  >
    <app-side-menu
      style="position: fixed; top: 55px; left: 0"
      class="flex-none"
      (itemClick)="isSidebarVisible = false"
    >
    </app-side-menu>
  </p-sidebar>

</ng-container>

<div
  [ngClass]="{
    'p-4': token$ | async,
    'main-content': token$ | async
  }"
  class="flex-grow-1"
>
  <router-outlet></router-outlet>

</div>

<app-footer #footer *ngIf="token$ | async" 
class="p-fixed w-screen">
</app-footer>

<p-toast>
  <ng-template let-message pTemplate="message">
    <p innerHtml="<h4>{{ message.summary }}</h4>{{ message.detail }}"></p>
  </ng-template>
</p-toast>

<p-confirmDialog key="def" [style]="{ width: '700px' }"></p-confirmDialog>
<app-user-change-password-form-dialog #pwdDialog></app-user-change-password-form-dialog>
